import _ from 'lodash';

/**
 * Formats url strings to prepend `http://` or `https://`.
 *
 * If url already contains http/https, then function returns link unchanged.
 *
 * @param link {string}: Pre-processed url.
 * @return {string}: Url with prepended http/https.
 */
const formatLink = (link) => {
    let result;
    const baseProtocol = "http://";
    const sslProtocol = "https://";

    if (_.startsWith(link, baseProtocol) || _.startsWith(link, sslProtocol)) {
        result = link;
    } else {
        result = baseProtocol + link;
    }
    return result;
};

export default formatLink;
